import { render, staticRenderFns } from "./purchasedListDetail.vue?vue&type=template&id=40f42c39&"
import script from "./purchasedListDetail.vue?vue&type=script&lang=js&"
export * from "./purchasedListDetail.vue?vue&type=script&lang=js&"
import style0 from "./purchasedListDetail.vue?vue&type=style&index=0&id=40f42c39&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports